import * as reduxAction from 'redux-actions';

import { IActivityModel } from '../Activity/Activity';


export const SET_SELECTED_ACTIVITY = "PORTAL_STATE.SET_SELECT_ACTIVITY"

export function setSlecetedActivtyAction(activityId: string,themeId: string = "", categoryId: string =""){
    return reduxAction.createAction(SET_SELECTED_ACTIVITY)({activityId,themeId, categoryId})
}


// WEBPACK FOOTER //
// ./src/Entities/PortalState/PortalState.Actions.ts